











































































































































































































































import { Component, Prop, Watch } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import BaseTab from './baseTab'
import { ExStore } from 'vuex'
import dayjs from 'dayjs'
import { Vitalsign, VitalsignSetting } from '@/types/vitalsign'
import { DateString } from '@/types/utils'
import { GlucoseSetting } from '@/types/glucose'
import ky from 'ky'

const TODAY = dayjs()
const DATE_FORMAT = 'YYYY/MM/DD'
const YEAR_RANGE = 3
const C_RED = 'red'
const C_BLUE = 'blue'

@Component({
  filters: {
    formatDate(date: string) {
      return dayjs(date).format('M/D')
    },
    formatTime(date: string) {
      return dayjs(date).format('HH:mm')
    },
    formatFloat(num: number) {
      return String(num).slice(0, 7)
    },
    formatVitalsignValue(value: number) {
      if (value && value >= 601) return 'Hi'
      if (value && value <= 19) return 'Lo'
      return value
    }
  },
  components: {
    VitalsignSetting: () =>
      import('@/components/vitalsign/VitalsignSetting.vue'),
    FlushMessage: () => import('@/components/common/FlushMessage.vue')
  }
})
export default class BloodSugarLevelTab extends mixins(BaseTab) {
  @Prop({ default: null, type: Number }) year!: number | null
  @Prop({ default: null, type: Number }) month!: number | null
  @Prop(Number) patientId!: number
  $store!: ExStore
  vitals: Vitalsign[] = []
  settings: Partial<VitalsignSetting> = {}
  glucoseSettings: Partial<GlucoseSetting> = {}

  get selectedYear() {
    return this.year || TODAY.year()
  }

  set selectedYear(year) {
    this.setRoute({ year })
  }

  get selectedMonth() {
    return this.month || TODAY.month() + 1
  }

  set selectedMonth(month) {
    this.setRoute({ month })
  }

  get selectedDate() {
    return `${this.selectedYear}年${this.selectedMonth}月`
  }

  set selectedDate(date: string) {
    const match = date.match(/(\d*)年(\d*)月/)
    if (match) {
      this.setRoute({
        year: Number(match[1]),
        month: Number(match[2])
      })
    }
  }

  get months() {
    const years = [...Array(YEAR_RANGE).keys()].map(i => TODAY.year() - i)
    const currentYear = TODAY.year()
    return years.reduce((dates, year) => {
      const lastMonth = year === currentYear ? TODAY.month() + 1 : 12
      const months = [...Array(lastMonth).keys()]
        .map(i => i + 1)
        .sort((a, b) => b - a)
      return dates.concat(months.map(m => `${year}年${m}月`))
    }, [] as string[])
  }

  get dailyVitals() {
    return this.vitals.reduce((dailyVitals, vital) => {
      const key = dayjs(vital.measureDatetime).format(DATE_FORMAT)
      const vitals: Vitalsign[] = key in dailyVitals ? dailyVitals[key] : []
      if (vital.glucose) dailyVitals[key] = [...vitals, vital]
      return dailyVitals
    }, {} as { [key: string]: Vitalsign[] })
  }

  @Watch('$route')
  async onRouteChange() {
    await this.getSetting()
    await this.getGlucoseSetting()
    await this.getVitalsign()
  }

  async created() {
    await this.getSetting()
    await this.getGlucoseSetting()
    await this.getVitalsign()
  }

  async getGlucoseSetting() {
    const res = await this.$api.glucose.fetchSetting({
      patientId: this.patientId
    })
    this.glucoseSettings = res
  }

  async getSetting() {
    const res = await this.$api.vitalsign.fetchSetting({
      patientId: this.patientId
    })
    this.settings = res
  }

  async getVitalsign() {
    const { before, after } = this.getBeforeAndAfter()
    const res = await this.$api.vitalsign.fetch({
      patientId: this.patientId,
      before,
      after
    })
    this.vitals = res.sort((a, b) => {
      if (a.measureDatetime < b.measureDatetime) return -1
      if (a.measureDatetime > b.measureDatetime) return 1
      return 0
    })
  }

  async save() {
    try {
      const payload = Object.assign({}, this.glucoseSettings)
      Object.entries(payload).map(([key, val]) => {
        if (val === '') delete payload[key as keyof GlucoseSetting]
      })
      await this.$api.glucose.putSetting({
        patientId: this.patientId,
        payload
      })
      localStorage.setItem('message', '保存されました')
      const flushMessage: any = this.$refs.flushMessage
      flushMessage.open()
    } catch (e) {
      if (e instanceof ky.HTTPError) {
        const errors = await e.response.json()
        this.$store.dispatch('alert/showErrorResponse', errors)
        return
      }
      console.error(e)
    }
  }

  setRoute(payload: { year?: number; month?: number }) {
    const q = Object.assign(
      {
        year: this.selectedYear,
        month: this.selectedMonth
      },
      payload
    )
    this.$router.push({
      name: 'BloodSugarLevelTab',
      query: {
        year: String(q.year),
        month: String(q.month)
      }
    })
  }

  getBeforeAndAfter() {
    const after = dayjs()
      .year(this.selectedYear)
      .month(this.selectedMonth - 1)
      .date(1)
    const before = after.add(1, 'month')
    return {
      before: before.format('YYYY-MM-DD') as DateString,
      after: after.format('YYYY-MM-DD') as DateString
    }
  }

  getStatusColor(type: string, value: number) {
    if (type === 'Glucose') {
      if (value && value >= 601) return C_RED
      if (value && value <= 19) return C_BLUE
    }
    const { settings } = this
    const emg = {
      chk: `emgIsLimitchk${type}` as keyof VitalsignSetting,
      high: `emgLimit${type}High` as keyof VitalsignSetting,
      low: `emgLimit${type}Low` as keyof VitalsignSetting
    }
    const warn = {
      chk: `warnIsLimitchk${type}` as keyof VitalsignSetting,
      high: `warnLimit${type}High` as keyof VitalsignSetting,
      low: `warnLimit${type}Low` as keyof VitalsignSetting
    }
    if (settings[emg.chk]) {
      const high = settings[emg.high]
      const low = settings[emg.low]
      if (high && value > high) return C_RED
      if (low && value < low) return C_BLUE
    }
    if (settings[warn.chk]) {
      const high = settings[warn.high]
      const low = settings[warn.low]
      if (high && value > high) return C_RED
      if (low && value < low) return C_BLUE
    }
    return ''
  }

  getVitalPosition(vital: Vitalsign, idx: number, vitals: Vitalsign[]): number {
    const date = dayjs(vital.measureDatetime)
    const hour = date.hour()
    const minute = Math.round(date.minute() / 10)
    const pos = hour * 60 + minute * 10
    if (idx) {
      // 直前のものと重ならないようにずらす
      const prevPos = this.getVitalPosition(vitals[idx - 1], 0, [])
      if (pos < prevPos + 30) {
        return pos + (prevPos + 30 - pos)
      }
    }
    return pos
  }

  getTime(date: string) {
    return dayjs(date).format('HH:mm')
  }

  getTimezone(time: number) {
    const timezone = [
      {
        index: 1,
        from: this.glucoseSettings.sleeptimeFr,
        to: this.glucoseSettings.sleeptimeTo
      },
      {
        index: 2,
        from: this.glucoseSettings.morningtimeFr,
        to: this.glucoseSettings.morningtimeTo
      },
      {
        index: 3,
        from: this.glucoseSettings.lunchtimeFr,
        to: this.glucoseSettings.lunchtimeTo
      },
      {
        index: 4,
        from: this.glucoseSettings.dinnertimeFr,
        to: this.glucoseSettings.dinnertimeTo
      }
    ]
    const hitzone = timezone.find(zone => {
      const from = zone.from || 0
      const to = zone.to || 0
      if (from > to && (time >= from || time < to)) return true
      return from <= time && time < to
    })
    return hitzone ? hitzone.index : 1
  }
}
